/* eslint-disable */
import session from './session';

export default {
    getOrganizationList(filter) {
        return session.get(`organization/${filter}`);
    },
    getOrganization(id) {
        return session.get(`organization/${id}/`);
    },
    deleteOrganization(id) {
        return session.delete(`organization/${id}/`);
    },
    createOrganization(data) {
        return session.post(`organization/`, data);
    },
    updateOrganization(id, data) {
        return session.patch(`organization/${id}/`, data );
    },
};